const EmailListMemType = Object.freeze({
  Subscribers: 1,
  UnSubscribers: 2,
  NonNatcaUnSubscribers: 3,
  AdditionalTeamUnSubscribers: 4,
});
export default EmailListMemType;
